import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import i18n from "./i18n";

export const DOMAIN = import.meta.env.VITE_DOMAIN_URL!;
export const BASE_URL = `${DOMAIN}/${import.meta.env.VITE_API_URL!}`;

export const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers: any) => {
      const token = localStorage.getItem("accessToken");
      headers.set("Accept", "application/json");

      if (i18n.language) {
        headers.set("Accept-Language", i18n.language);
      }

      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: () => ({}),
});
